export interface NationalityOption {
  value: string;
  labelKey: string;
}

export const NATIONALITY_OPTIONS: NationalityOption[] = [
  { value: "Казах", labelKey: "kazakh" },
  { value: "Русский", labelKey: "russian" },
  { value: "Узбек", labelKey: "uzbek" },
  { value: "Украинец", labelKey: "ukrainian" },
  { value: "Уйгур", labelKey: "uyghur" },
  { value: "Татарин", labelKey: "tatar" },
  { value: "Немец", labelKey: "german" },
  { value: "Туркмен", labelKey: "turkmen" },
  { value: "Азербайджанец", labelKey: "azerbaijani" },
  { value: "Армянин", labelKey: "armenian" },
  { value: "Кореец", labelKey: "korean" },
  { value: "Чеченец", labelKey: "chechen" },
  { value: "Ингуш", labelKey: "ingush" },
  { value: "Белорус", labelKey: "belarusian" },
  { value: "Таджик", labelKey: "tajik" },
  { value: "Кыргызстанец", labelKey: "kyrgyz" },
  { value: "Турок", labelKey: "turk" },
  { value: "Китаец", labelKey: "chinese" },
  { value: "Дунганин", labelKey: "dungan" },
  { value: "Польяк", labelKey: "polish" },
  { value: "Грек", labelKey: "greek" },
  { value: "Курык", labelKey: "kumyk" },
  { value: "Каракалпак", labelKey: "karakalpak" },
  { value: "Башкир", labelKey: "bashkir" },
  { value: "Бурят", labelKey: "buryat" },
  { value: "Калмык", labelKey: "kalmyk" },
  { value: "Лезгин", labelKey: "lezgin" },
  { value: "Осетин", labelKey: "ossetian" },
  { value: "Мариец", labelKey: "mari" },
  { value: "Мордвин", labelKey: "mordvin" },
  { value: "Чуваш", labelKey: "chuvash" },
  { value: "Еврей", labelKey: "jewish" },
  { value: "Болгарин", labelKey: "bulgarian" },
  { value: "Румын", labelKey: "romanian" },
  { value: "Серб", labelKey: "serbian" },
  { value: "Черногорец", labelKey: "montenegrin" },
  { value: "Хорват", labelKey: "croatian" },
  { value: "Македонец", labelKey: "macedonian" },
  { value: "Латыш", labelKey: "latvian" },
  { value: "Литовец", labelKey: "lithuanian" },
  { value: "Эстонец", labelKey: "estonian" },
  { value: "Финн", labelKey: "finnish" },
  { value: "Швед", labelKey: "swedish" },
  { value: "Норвежец", labelKey: "norwegian" },
  { value: "Англичанин", labelKey: "english" },
  { value: "Американец", labelKey: "american" },
  { value: "Француз", labelKey: "french" },
  { value: "Итальянец", labelKey: "italian" },
  { value: "Испанец", labelKey: "spanish" },
  { value: "Португалец", labelKey: "portuguese" },
  { value: "Араб", labelKey: "arab" },
  { value: "Афганец", labelKey: "afghan" },
  { value: "Иранец", labelKey: "iranian" },
  { value: "Пакистанец", labelKey: "pakistani" },
  { value: "Индиец", labelKey: "indian" },
  { value: "Курд", labelKey: "kurd" },
  { value: "Ассириец", labelKey: "assyrian" },
  { value: "Гагауз", labelKey: "gagauz" },
  { value: "Караим", labelKey: "karaim" },
  { value: "Молдаванин", labelKey: "moldovan" },
  { value: "Венгр", labelKey: "hungarian" },
  { value: "Чех", labelKey: "czech" },
  { value: "Словак", labelKey: "slovak" },
  { value: "Японец", labelKey: "japanese" },
];

